import { useEffect } from 'react';
import { getTMSFormat } from '@raisin/cp-utils';
import { initTransifexWithFallback } from '@raisin/translations-backup';

const tx = initTransifexWithFallback({
  token: process.env.NEXT_PUBLIC_TRANSIFEX_NATIVE_TOKEN,
  filterTags: 'customerPortal',
});

export const useTranslationProvider = ({ locale }) => {
  useEffect(() => {
    async function loadLocale() {
      try {
        await tx.setCurrentLocale(getTMSFormat(locale));
      } catch (error) {
        console.warn(error);
      }
    }
    loadLocale();
  }, [locale]);

  return locale;
};
